import React from "react";
import { Link } from "react-router-dom";
import "../css2/ExploreCapsulesCTA.css";

export default function ExploreCapsulesCTA() {
  return (
    <div className="capsules-cta-wrapper">
      <div className="capsules-cta-card">

        {/* Mascot */}
        <img
          src="/assets/images/capsule-mascot.png"
          alt="Helprr Capsule Mascot"
          className="capsules-cta-mascot"
        />

        <div className="capsules-cta-eyebrow">✨ Need something quick instead?</div>

        <p className="capsules-cta-sub">
          Fast 2-minute grounding activities.
        </p>

        <Link to="/micro-exercises" className="capsules-cta-button">
          Explore Capsules →
        </Link>
      </div>
    </div>
  );
}
